
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const values = [
  {
    icon: 'ri-lightbulb-flash-line',
    title: 'Innovation First',
    description:
      'We challenge conventions and explore emerging technologies to deliver solutions that keep our clients ahead of the curve.',
    accent: 'from-[#0066CC] to-[#004D99]',
  },
  {
    icon: 'ri-shield-star-line',
    title: 'Unwavering Integrity',
    description:
      'Transparency and honesty form the bedrock of every relationship. We earn trust through consistent ethical practices.',
    accent: 'from-[#0066CC] to-[#004D99]',
  },
  {
    icon: 'ri-group-2-line',
    title: 'True Partnership',
    // Use double quotes to avoid escaping single quotes inside the string
    description:
      "We don't just deliver projects — we invest in long-term partnerships, aligning our success with our clients' growth.",
    accent: 'from-[#0066CC] to-[#004D99]',
  },
  {
    icon: 'ri-award-line',
    title: 'Relentless Excellence',
    description:
      'Every line of code, every strategy, every interaction reflects our commitment to the highest standards of quality.',
    accent: 'from-[#0066CC] to-[#004D99]',
  },
];

export default function Values() {
  const header = useScrollAnimation();
  const grid = useScrollAnimation({ rootMargin: '0px 0px -40px 0px' });

  const delayClasses = [
    'animation-delay-100',
    'animation-delay-200',
    'animation-delay-300',
    'animation-delay-400',
  ];

  return (
    <section className="py-28 px-8 bg-[#F9FAFB]">
      <div className="max-w-[1400px] mx-auto">
        <div
          ref={header.ref}
          className={`text-center mb-20 transition-all duration-700 ${
            header.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <span className="text-xs font-semibold text-[#0066CC] uppercase tracking-[0.2em] mb-4 block">
            What We Stand For
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A2332] mb-4">
            Our Core Values
          </h2>
          <p className="text-base text-gray-600 max-w-xl mx-auto">
            The principles that guide every decision, every project, and every
            relationship we build.
          </p>
        </div>

        <div ref={grid.ref} className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((value, index) => (
            <div
              key={index}
              className={`group bg-white rounded-2xl p-8 border border-gray-100 hover:border-[#0066CC]/20 hover:shadow-xl transition-all duration-500 hover:-translate-y-2 cursor-pointer ${
                grid.isVisible
                  ? `animate-fade-in-up ${delayClasses[index]}`
                  : 'opacity-0-start'
              }`}
            >
              <div
                className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${value.accent} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}
              >
                <i className={`${value.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-[#1A2332] mb-3">
                {value.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
